import PropTypes from 'prop-types';
import React from 'react';
import { get } from 'lodash';
import { ValidationMessageTile } from 'web-ui-components/lib/layout/content';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { ContentProps, PaymentReasonProps } from '../state/propTypes';

const PaymentReason = (props) => {
	const handleReasonChange = (id) => {
		const reason = props.reasons.find((r) => r.id === id);
		const selectedReason = get(reason, 'header', '');
		props.setUIError(false);
		props.updateReason(id, selectedReason);
	};

	const {
		content: { invalidPaymentReason, reasonsPageHeader, reasonsPageSubHeader },
		reasonId,
		reasons = [],
		isUiError,
	} = props;

	const renderReasons = () => {
		const items = reasons.map(({ description, id, header }) => ({
			id,
			labelText: header,
			subLabelText: description,
		}));
		return (
			<GenericRadio.StackedSet
				groupName="radio-group-b"
				items={items}
				onChange={(selectedId) => handleReasonChange(selectedId)}
				selectedId={reasonId}
			/>
		);
	};

	return (
		<div>
			<PageHeading data-test-id="reason-error">{reasonsPageHeader}</PageHeading>
			<StandardBody>{reasonsPageSubHeader}</StandardBody>
			{renderReasons()}
			{isUiError && (
				<div id="reasonErrorMsg">
					<ValidationMessageTile messageText={invalidPaymentReason} />
				</div>
			)}
		</div>
	);
};

PaymentReason.propTypes = {
	content: PropTypes.shape(ContentProps).isRequired,
	reasonId: PropTypes.string,
	reasons: PropTypes.arrayOf(PropTypes.shape(PaymentReasonProps)).isRequired,
	setUIError: PropTypes.func,
	isUiError: PropTypes.bool.isRequired,
	updateReason: PropTypes.func.isRequired,
};

export default PaymentReason;
